import { createSelector } from "reselect";
import { parse as parsePlatform } from "platform";

const getRawUserAgent = (state) => state.device.rawUserAgent;

export default createSelector(getRawUserAgent, (rawUserAgent) =>
  parsePlatform(rawUserAgent),
);
